import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ListColumnType, ListFilterType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { useModal } from 'components/modals/ModalContext';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';
import DivisionForm from '../../views/environments/DivisionForm';
import CompanyDetailsEditForm from '../settings/company_details/CompanyDetailsEditForm';

// Rename the name of the function:
const DivisionList: React.FC = () => {
    const { t } = useTranslation();
    const { initializeModal } = useModal();
    const { refetchDivisions } = useSettingsDivision();

    // Store the refetch function of the list to refetch after editing
    const [refetchList, setRefetchListState] = useState<(() => void) | null>(null);
    const setRefetchList = useCallback((newRefetchList: () => void) => {
        setRefetchListState(() => newRefetchList);
    }, []);

    // Specify the options of this list:
    const query = {
        endpoint: 'get_division_list',
        defaultParams: { 'is_active': true },
        object: 'division'
    }
    const objectName = 'division.general.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deactivated'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <DivisionForm />;

    // Open the company details modal when clicking a division row
    const onRowClick = (rowData: any) => {
        initializeModal(
            <CompanyDetailsEditForm
                division={{ id: rowData.id, is_main: rowData.is_main, name: rowData.name }}
            />, {
                title: t('company_details.general.edit_company_details_title'),
                modalSize: 'medium',
                onSuccess: () => {
                    // Refetch the list and the divisions of the settings menu selector
                    refetchList && refetchList();
                    refetchDivisions();
                },
            }
        )
    };

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'name', label: 'division.general.division_name_label' },
    ];

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'division.general.active_divisions_label',
            params: { 'is_active': true }
        },
        {
            id: 'inactive',
            label: 'division.general.inactive_divisions_label',
            params: { 'is_active': false }
        },
    ]

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            filters={filters}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            setRefetchList={setRefetchList}
        />
    );
};

export default DivisionList;
